<div class="bg-gray-200 dark:bg-gray-900 bg-cover" style="background-image: url('pseudo-bg.jpg')">
  <!-- We've used 3xl here, but feel free to try other max-widths based on your needs -->
  <div
    class="flex flex-col mx-auto max-w-5xl sm:max-w-lg lg:max-w-5xl bg-white dark:bg-gray-800 max-h-dvh"
  >
    <div
      class="flex flex-wrap items-center justify-between sm:flex-nowrap bg-primary-500 px-4 py-3 sm:px-6"
    >
      <div class="cursor-default">
        @if (listing()?.saleType === 'preowned') {
          <p class="text-base font-header font-semibold text-white">VLS#: {{ listing()!.vls }}</p>
        } @else if (listing()) {
          <p class="text-base font-header font-semibold text-white">VNH#: {{ listing()!.vls }}</p>
        } @else {
          <p class="text-base font-header font-semibold text-white">Unknown</p>
        }
      </div>

      <button
        type="button"
        (click)="navigateToHomefinder()"
        class="rounded-md my-auto px-3 py-2 text-sm text-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/30 dark:focus-visible:outline-white/30 h-10 items-center hover:bg-primary-400 dark:hover:bg-white/5 flex flex-row gap-2 cursor-pointer"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          data-slot="icon"
          aria-hidden="true"
          class="size-5"
        >
          <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <!-- <app-modal-close-button [modalId]="modalId()" class="absolute top-0 right-0 pt-4 pr-4 block" /> -->
    </div>

    <div class="p-4 pb-20 overflow-y-auto">
      @if (listing()) {
        <app-listing-details [listing]="listing()!" />
      }
    </div>
  </div>
</div>

<!-- Contact FAB -->
@defer {
  <app-contact-fab />
}

<!-- Modals -->
@defer {
  <app-modals [disableListingModal]="true" class="absolute top-0" />
}
